import { Injectable, Type, ComponentRef, ViewContainerRef, ComponentFactoryResolver, ComponentFactory } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetailPageService {

  container: ViewContainerRef;

  constructor(
    private resolver: ComponentFactoryResolver
  ) { }

  getComponentFactory<T>(component: Type<T>): ComponentFactory<T> {
    return this.resolver.resolveComponentFactory<T>(component);
  }

  addComponent<T>(container: ViewContainerRef, factory: ComponentFactory<T>): ComponentRef<T> {
    return container.createComponent(factory);
  }

  setDetailContainer(container: ViewContainerRef) {
    this.container = container;
  }

  loadComponent<T>(component: Type<T>): ComponentRef<T>  {
    this.container.clear();
    return this.addComponent(this.container, this.getComponentFactory(component));
  }

  removeComponent() {
    this.container.clear();
  }
}
